import Toggle from '@jetbrains/ring-ui/components/toggle/toggle'
import classNames from 'classnames'
import type {CSSProperties} from 'react'

import {toggleArchivedProjectsInSidebar} from './SidebarFooter.actions'

import styles from './SidebarFooter.css'

import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'

type Props = {
  className?: string
  style?: CSSProperties
}

export default function SidebarFooter({className, style}: Props) {
  const dispatch = useAppDispatch()
  const toggleArchivedProjects: () => void = () => {
    dispatch(toggleArchivedProjectsInSidebar())
  }
  const showArchivedProjects = useAppSelector(state => state.projectsSidebar.showArchivedProjects)

  return (
    <div className={classNames(className, styles.container)} style={style} data-inside-sidebar>
      <Toggle
        className={styles.archiveToggle}
        defaultChecked={showArchivedProjects}
        onChange={toggleArchivedProjects}
        leftLabel={<span>{'Show archived'}</span>}
      />
    </div>
  )
}
